import Pulse from "src/Component/Pulse";
import PulseGrey from "src/Component/PulseGrey";
import "./index.sass";
import TypewriterText from "./TypewriterText";
import { useEffect } from "react";

interface MicProps {
  step: number;
  setStep: (step: number) => void;
}

const Mic = ({ step, setStep }: MicProps) => {
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (step === 1) {
      timeout = setTimeout(() => setStep(2), 2000);
    }
    if (step === 2) {
      timeout = setTimeout(() => setStep(3), 1000);
    }
    if (step === 3) {
      timeout = setTimeout(() => setStep(4), 600);
    }
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  return (
    <div className={`mic ${step <= 2 ? "" : "hide"} ${step > 3 ? "hide2" : ""}`}>
      <Pulse
        onClick={() => setStep(1)}
        style={{
          width: "var(--width-60)",
          left: "var(--width-140)",
          bottom: "var(--height-304)",
          zIndex: 1000,
          position: "absolute",
          transition: "all 0.5s ease",
          transform: "translate(50%, 19%)",
          opacity: step === 0 ? 1 : 0,
        }}
      />
      {
        <PulseGrey
          style={{
            position: "absolute",
            transition: "all 0.5s ease",
            zIndex: 0,
            width: "var(--width-600)",
            height: "var(--height--200)",
            opacity: step === 1 ? 1 : 0,
          }}
        />
      }
      <svg style={{ zIndex: 1 }} width="148" height="148" viewBox="0 0 148 148" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="74" cy="74" r="74" fill="#067AB4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.2576 46.7539H73.874C68.976 46.7539 65.0053 50.7246 65.0053 55.6227V74.2082C65.0053 79.1063 68.976 83.077 73.874 83.077H74.2576C79.1557 83.077 83.1263 79.1063 83.1263 74.2082V55.6227C83.1263 50.7246 79.1557 46.7539 74.2576 46.7539ZM75.6474 91.5023C84.946 90.8183 92.3517 84.1323 92.1286 74.7878C92.1068 73.8768 91.3506 73.1559 90.4396 73.1777C89.5286 73.1994 88.8077 73.9556 88.8295 74.8666C89.0169 82.7148 82.3712 88.2602 74.0653 88.2602C65.4704 88.2602 59.1711 83.1925 59.1711 74.8272C59.1711 73.9159 58.4324 73.1772 57.5211 73.1772C56.6098 73.1772 55.8711 73.9159 55.8711 74.8272C55.8711 84.6069 62.9177 90.8282 72.3474 91.4997V99.5888L72.3603 99.7958C72.4621 100.609 73.1562 101.239 73.9974 101.239C74.9087 101.239 75.6474 100.5 75.6474 99.5888V91.5023Z"
          fill="#E8E8E8"
        />
      </svg>
      {step >= 1 && <TypewriterText text={"Bambi..."} />}
    </div>
  );
};

export default Mic;
